module.exports = __webpack_public_path__ + "img/mapnew_small3.97396d29.png";